<div class="p-3 mb-4 mat-title dialog-title">Activity Log</div>

<div class="pl-3 m-3" style="overflow: auto;height: 75%;">
  <div class="wrapper">
  <ol class="StepProgress m-0">
    <li *ngFor="let entry of logs" class="StepProgress-item">
      <strong>{{ entry.formattedDate}}</strong> 
      <span>{{entry.incidentLogDescription}}</span>
    </li>
  </ol>
</div>
</div>


